"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getWrapperElementChildren = exports.DangerousDeferredRenderWrapper = void 0;

var _react = require("react");

/* eslint-disable no-console, zillow/react/require-default-props */

/**
 * Deferred Renderer wrapper component. This common element structure is necessary for all deferment
 * render types to work together, and the nested `div` is required for `Intersection Observer`,
 * `ref`s, and `dangerouslySetInnerHTML` mechanisms to work properly. Note: we must use
 * `createElement` instead of TSX syntax to give us control over intrinsic element typing while
 * allowing for custom wrapperType type strings.
 */
var DeferredRenderWrapper = function DeferredRenderWrapper(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      children = _ref.children,
      innerWrapperProps = _ref.innerWrapperProps,
      renderStrat = _ref.renderStrat,
      wrapperProps = _ref.wrapperProps,
      _ref$wrapperType = _ref.wrapperType,
      wrapperType = _ref$wrapperType === void 0 ? 'div' : _ref$wrapperType;

  var uniqueChildren = Array.isArray(children) ? children.map(function (child, key) {
    return Object.assign({}, child, {
      key: key
    });
  }) : children;
  var innerWrapper = /*#__PURE__*/(0, _react.createElement)('div', innerWrapperProps, uniqueChildren);
  return /*#__PURE__*/(0, _react.createElement)(wrapperType, Object.assign({}, wrapperProps, {
    'data-renderstrat': renderStrat !== null && renderStrat !== void 0 ? renderStrat : renderStrat
  }), innerWrapper);
};
/* A dangerous, childless form of the DeferredRenderWrapper */


var DangerousDeferredRenderWrapper = function DangerousDeferredRenderWrapper(_ref2) {
  var renderStrat = _ref2.renderStrat,
      ref = _ref2.refCallback,
      wrapperProps = _ref2.wrapperProps,
      wrapperType = _ref2.wrapperType;
  var dangerWrapperProps = {
    renderStrat: renderStrat,
    innerWrapperProps: {
      dangerouslySetInnerHTML: {
        __html: ''
      },
      suppressHydrationWarning: true
    },
    wrapperProps: Object.assign({}, wrapperProps, {
      // Set the min height and width of the wrapper to 1px to avoid ambiguous
      // Intersection Observer behavior. This gets removed on full render if it turns out
      // the final state of the component should actually be 0. See
      // https://github.com/w3c/IntersectionObserver/issues/69
      style: {
        minHeight: '1px',
        minWidth: '1px'
      },
      ref: ref
    }),
    wrapperType: wrapperType
  };
  return DeferredRenderWrapper(dangerWrapperProps);
};
/**
 * Return the children of the rendered DeferredRenderWrapper DOM element as DOM elements. If there
 * are no children, return null. Note: Use this instead of trying to select the correct elements
 * from the wrapper DOM element yourself in ref callbacks because the structure of the wrapper is
 * private and may change in the future!
 */


exports.DangerousDeferredRenderWrapper = DangerousDeferredRenderWrapper;

var getWrapperElementChildren = function getWrapperElementChildren(outerWrapper) {
  var innerWrapper = outerWrapper === null || outerWrapper === void 0 ? void 0 : outerWrapper.firstElementChild; // Log a warning and return null if the inner wrapper is missing

  if (!innerWrapper) {
    console.warn('Invalid DeferredRenderWrapper element');
    return null;
  } // Return null if no children are found


  if (!innerWrapper.children.length) return null;
  return innerWrapper.children;
};

exports.getWrapperElementChildren = getWrapperElementChildren;
var _default = DeferredRenderWrapper;
exports.default = _default;